import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import tw from "twin.macro"
import anime from "animejs"

import { LoaderIcon } from "@components/icons"

const StyledLoader = styled.div`
  ${tw`flex items-center justify-center fixed inset-0 z-50 bg-neutralDark w-full h-full`}
  & {
    .loader-wrapper {
      ${tw`w-max max-w-xs`}
      svg .logo__group__path {
        ${tw`opacity-0`}
        stroke-dasharray: 1000;
        stroke-dashoffset: 1000;
      }
    }
  }
`

const Loader = ({ finishLoading }) => {
  const loaderIcon = useRef(null)

  const animate = () => {
    const loader = anime.timeline({
      complete: () => finishLoading(),
    })

    loader
      .add({
        targets: "#logo__group__path",
        delay: 300,
        opacity: 1,
        duration: 1500,
        strokeDashoffset: [anime.setDashoffset, 0],
        easing: "easeInOutQuart",
      })
      .add({
        targets: "#logo__group__path",
        delay: 1,
        duration: 1500,
        easing: "easeInOutQuart",
        fill: [anime.fill, "#06f"],
      })
      .add({
        targets: "#logo",
        delay: 1,
        duration: 300,
        easing: "easeInOutQuart",
        scale: 0.1,
        opacity: 0,
      })
      .add({
        targets: ".loader",
        duration: 200,
        easing: "easeInOutQuart",
        opacity: 0,
        zIndex: -1,
      })
  }

  useEffect(() => animate(), [])

  return (
    <StyledLoader className="loader">
      <div className="loader-wrapper">
        <LoaderIcon loaderIcon={loaderIcon} />
      </div>
    </StyledLoader>
  )
}

Loader.propTypes = {
  finishLoading: PropTypes.func.isRequired,
}

export default Loader
